const externalLinks = {
	main: "https://ciclik.com.br",
	blog: "https://ciclik.com.br/blog",
	allAboutESG: "https://ciclik.com.br/tudo-sobre-esg",
	solidWastePolicy: "https://ciclik.com.br/politica-de-residuos-solidos",
	polluterPrinciple: "https://ciclik.com.br/principio-do-poluidor-pagador",
};

export default externalLinks;
